import { Injectable } from '@angular/core';
import { ApiService } from '../api/api.service';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class VehiculosService {

  constructor(public Api: ApiService) { }

  getVehiculosSearch(data: any) {
    return this.Api.get(`${environment.APIMAIN}/vehicle/${data}`, environment.apiUrl, 'AA');
  }

  postCrearVehiculos(data: any) {
    return this.Api.post('/vehicle', data, `${environment.apiUrl}${environment.APIMAIN}`, 'AA');
  }

  putEditarVehiculos(data: any) {
    return this.Api.put('/vehicle', data, `${environment.apiUrl}${environment.APIMAIN}`, 'AA');
  }

  postIniciarServicioVehiculo(data: any) {
    return this.Api.post('/vehicle_notes/start/service', data, `${environment.apiUrl}${environment.APIMAIN}`, 'AA');
  }

  getVehiculosHistorial(data: any) {
    return this.Api.get(`${environment.APIMAIN}/vehicle_notes/historical/${data}`, environment.apiUrl, 'AA');
  }
  
}
